// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".xgplayer-skin-custom .xgplayer-placeholder{display:block;flex:1;order:3}", ""]);
// Exports
module.exports = exports;
